import { render, staticRenderFns } from "./DiscountCustomersUnlink.vue?vue&type=template&id=6b7d90b0&scoped=true"
import script from "./DiscountCustomersUnlink.vue?vue&type=script&lang=js"
export * from "./DiscountCustomersUnlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d90b0",
  null
  
)

export default component.exports